module.exports = __webpack_public_path__ + "static/media/house-of-terpenes-group.71afc251.png";